<div class="card flex justify-content-center">
  <p-inputgroup styleClass="p-masked-calendar" [class.p-masked-calendar-disabled]="disabled()">
    <p-inputMask
      #inputMaskRef
      [(ngModel)]="inputMaskValue"
      (ngModelChange)="onInputMaskChange($event)"
      [disabled]="_disabled()"
      [required]="required()"
      class="w-full"
      styleClass="w-full"
      mask="99/99/9999"
      placeholder="DD/MM/YYYY"
      slotChar="DD/MM/YYYY"
      (onBlur)="onInputMaskBlur($event)" />
    <p-inputgroup-addon>
      <p-datepicker
        [(ngModel)]="calendarValue"
        (ngModelChange)="onChange($event)"
        (onBlur)="onTouched()"
        appendTo="body"
        (onSelect)="onCalendarSelect($event)"
        [readonlyInput]="true"
        [showOnFocus]="false"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        [disabled]="disabled()"
        [required]="required()"
        [maxDate]="maxDate()"
        [minDate]="minDate()"
        [disabledDates]="disabledDates()" />
    </p-inputgroup-addon>
  </p-inputgroup>
</div>
